module.exports = __webpack_public_path__ + "static/media/Woman-Daughter-Swim.8e68c829.png";